<p-splitter
  [style]="config().style"
  [styleClass]="config().styleClass"
  [panelSizes]="config().panelSizes"
  [minSizes]="config().minSizes"
  [layout]="config()?.layout ?? 'horizontal'"
  (onResizeStart)="startResize($event)"
  (onResizeEnd)="endResize($event)"
>
  @for (element of config().panel; let i = $index; track element.panel) {
    <ng-template pTemplate>
      <ng-container *ngTemplateOutlet="panelTemplate; context: { $implicit: element, index: i }" />
    </ng-template>
  }
</p-splitter>
